<template>
    <div :id="idDelInput">
        <body>
            <DxHtmlEditor :height="altura">
                <DxMediaResizing :enabled="true"/>
                <DxToolbar :multiline="true">
                    <DxItem v-if="barraHerramientas.undo" format-name="undo"/>
                    <DxItem v-if="barraHerramientas.redo" format-name="redo"/>
                    <DxItem v-if="barraHerramientas.undo || barraHerramientas.redo" format-name="separator"/>
                    <DxItem v-if="barraHerramientas.size"
                        :format-values="sizeValues"
                        format-name="size"
                        />
                    <DxItem v-if="barraHerramientas.font"
                        :format-values="fontValues"
                        format-name="font"
                        />
                    <DxItem v-if="barraHerramientas.size || barraHerramientas.font" format-name="separator"/>
                    <DxItem v-if="barraHerramientas.bold" format-name="bold"/>
                    <DxItem v-if="barraHerramientas.italic" format-name="italic"/>
                    <DxItem v-if="barraHerramientas.strike" format-name="strike"/>
                    <DxItem v-if="barraHerramientas.underline" format-name="underline"/>
                    <DxItem v-if="barraHerramientas.bold || barraHerramientas.italic || barraHerramientas.strike || barraHerramientas.underline" format-name="separator"/>
                    <DxItem v-if="barraHerramientas.alignLeft" format-name="alignLeft"/>
                    <DxItem v-if="barraHerramientas.alignCenter" format-name="alignCenter"/>
                    <DxItem v-if="barraHerramientas.alignRight" format-name="alignRight"/>
                    <DxItem v-if="barraHerramientas.alignJustify" format-name="alignJustify"/>
                    <DxItem v-if="barraHerramientas.alignLeft || barraHerramientas.alignCenter || barraHerramientas.alignRight || barraHerramientas.alignJustify" format-name="separator"/>
                    <DxItem v-if="barraHerramientas.orderedList" format-name="orderedList"/>
                    <DxItem v-if="barraHerramientas.bulletList" format-name="bulletList"/>
                    <DxItem v-if="barraHerramientas.orderedList || barraHerramientas.bulletList" format-name="separator"/>
                    <DxItem v-if="barraHerramientas.header"
                        :format-values="headerValues"
                        format-name="header"
                        />
                    <DxItem v-if="barraHerramientas.header" format-name="separator"/>
                    <DxItem v-if="barraHerramientas.color" format-name="color"/>
                    <DxItem v-if="barraHerramientas.background" format-name="background"/>
                    <DxItem v-if="barraHerramientas.color || barraHerramientas.background" format-name="separator"/>
                    <DxItem v-if="barraHerramientas.link" format-name="link"/>
                    <DxItem v-if="barraHerramientas.image" format-name="image"/>
                    <DxItem v-if="barraHerramientas.link || barraHerramientas.image" format-name="separator"/>
                    <DxItem v-if="barraHerramientas.clear" format-name="clear"/>
                    <DxItem v-if="barraHerramientas.codeBlock" format-name="codeBlock"/>
                    <DxItem v-if="barraHerramientas.blockquote" format-name="blockquote"/>
                </DxToolbar>
                <div v-html="contenido"/>
            </DxHtmlEditor>
        </body>
    </div>
</template>
<script>
import { DxHtmlEditor, DxToolbar, DxMediaResizing,DxItem } from 'devextreme-vue/html-editor';

export default {
    components: {
        DxHtmlEditor: DxHtmlEditor, 
        DxToolbar: DxToolbar, 
        DxMediaResizing: DxMediaResizing,
        DxItem: DxItem
    },
    props: {      
      idDelInput: String,      
      altura: String,
      valorEditor: String,
      barraHerramientas: Object
    },
    data() {
        return {
            sizeValues: ['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt'],
            fontValues: ['Arial', 'Courier New', 'Georgia', 'Impact', 'Lucida Console', 'Tahoma', 'Times New Roman', 'Verdana'],
            headerValues: [false, 1, 2, 3, 4, 5]
        }
    },
    methods: {
        
    },
    computed: {
       contenido: {
            get() {
                return this.valorEditor;
            },
            set(val) {
                this.$emit('cambioContenido', val);
            }
        }
    },
}
</script>
<style scoped>
  /* body {
    background-color: white;
    color: black; 
    font-size: 0.8rem;
    overflow-x: hidden;
  } */
</style>


// WEBPACK FOOTER //
// src/components/SINOJ/Comun/CEditorTexto.vue